import { Box, Button } from '@mui/material';
import { styled } from '@mui/material';
import { pxToRem } from '~/theme/typography';

type TInstitutionButton = {
  isSelected: boolean;
};

export const header = {
  Container: styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    height: '56px',
    position: 'fixed',
    width: '100vw',
    padding: '0px 40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    top: '0px',
    zIndex: '2',
  })),
  LeftCluster: styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
  })),
  LogoContainer: styled(Box)(() => ({
    height: '45px',
    position: 'relative',
  })),
  NavButton: styled(Button)(() => ({
    fontWeight: 700,
    fontSize: pxToRem(14),
    textTransform: 'none',
  })),
  InstitutionGroup: styled(Box)(() => ({
    display: 'flex',
    gap: '32px',
  })),
  InstitutionButton: styled(Button)<TInstitutionButton>(
    ({ theme, isSelected }) => ({
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontWeight: '700',
      fontSize: pxToRem(14),
      color: isSelected ? theme.palette.info.main : theme.palette.grey[800],
    }),
  ),
  ProfileContainer: styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: '700',
    fontSize: '14px',
  })),
};
